import { createAction } from 'redux-actions';
import { PapiDeviation, PapiGallection } from '@wix/da-papi-types';
import { BatchAction } from '../../types/store';
import {
  BatchEditTagsOperation,
  BatchEditTitleOperation,
  BatchEditLabel,
  BatchEditLicense,
  BatchEditAttributeName,
  RunningBatch,
  BatchType,
} from '../../types/batchActions';

export const selectBatchAction = createAction(
  'STUDIO.SELECT_BATCH_ACTION',
  (batchAction: BatchAction) => ({ batchAction })
);

export const cancelBatchAction = createAction(
  'STUDIO.CANCEL_BATCH_ACTION',
  () => ({})
);

export const batchStart = createAction(
  'STUDIO.BATCH_START',
  (batchType: BatchType, batchId: number, deviationIds: number[]) => ({
    batchType,
    batchId,
    deviationIds,
  })
);

export const batchFinish = createAction(
  'STUDIO.BATCH_FINISH',
  (
    batchId: number,
    batch: RunningBatch,
    processedCount: number,
    failedCount: number
  ) => ({ batchId, batch, processedCount, failedCount })
);

export const batchError = createAction(
  'STUDIO.BATCH_ERROR',
  (batchType: BatchType, message: string, errorCode: number | null) => ({
    batchType,
    message,
    errorCode,
  })
);

export const batchEditTitle = createAction(
  'STUDIO.BATCH_EDIT_TITLE',
  (operation: BatchEditTitleOperation, title: string) => ({
    operation,
    title,
  })
);

export const batchEditTags = createAction(
  'STUDIO.BATCH_EDIT_TAGS',
  (operation: BatchEditTagsOperation, tags: string[]) => ({
    operation,
    tags,
  })
);

export const batchEditLabels = createAction(
  'STUDIO.BATCH_EDIT_LABELS',
  (labels: BatchEditLabel[]) => ({ labels })
);

export const batchEditLicense = createAction(
  'STUDIO.BATCH_EDIT_LICENSE',
  (license: BatchEditLicense) => ({ license })
);

export const batchEditDescription = createAction(
  'STUDIO.BATCH_EDIT_DESCRIPTION',
  (newState: any) => ({ newState })
);

export const batchLoadGalleries = createAction(
  'STUDIO.BATCH_LOAD_GALLERIES',
  () => ({})
);

export const batchLoadGalleriesFailure = createAction(
  'STUDIO.BATCH_LOAD_GALLERIES_FAILURE',
  () => ({})
);

export const batchLoadGalleriesSuccess = createAction(
  'STUDIO.BATCH_LOAD_GALLERIES_SUCCESS',
  (galleries: PapiGallection[]) => ({ galleries })
);

export const batchEditGallery = createAction(
  'STUDIO.BATCH_EDIT_GALLERY',
  (targetFolderId: number[]) => ({ targetFolderId })
);

export const batchLoadTiers = createAction(
  'STUDIO.BATCH_LOAD_TIERS',
  () => ({})
);

export const batchLoadTiersFailure = createAction(
  'STUDIO.BATCH_LOAD_TIERS_FAILURE',
  () => ({})
);

export const batchLoadTiersSuccess = createAction(
  'STUDIO.BATCH_LOAD_TIERS_SUCCESS',
  (tiers: PapiDeviation[]) => ({ tiers })
);

export const batchEditTier = createAction(
  'STUDIO.BATCH_EDIT_TIER',
  (tierIds: number[]) => ({ tierIds })
);

export const batchEditAttribute = createAction(
  'STUDIO.BATCH_EDIT_ATTRIBUTE',
  (attrName: BatchEditAttributeName, attrValue: boolean) => ({
    attrName,
    attrValue,
  })
);

export const batchEditDisplayOptions = createAction(
  'STUDIO.BATCH_EDIT_DISPLAY_OPTIONS',
  (displayResolution: number, addWatermark: boolean) => ({
    displayResolution,
    addWatermark,
  })
);

export const batchEditPreset = createAction(
  'STUDIO.BATCH_EDIT_PRESET',
  (presetId: number) => ({ presetId })
);

export const batchPublish = createAction('STUDIO.BATCH_PUBLISH', () => ({}));

export const batchUnpublish = createAction(
  'STUDIO.BATCH_UNPUBLISH',
  () => ({})
);

export const batchSchedule = createAction(
  'STUDIO.BATCH_SCHEDULE',
  (scheduleTs: number) => ({ scheduleTs })
);

export const batchDoDelete = createAction('STUDIO.BATCH_DO_DELETE', () => {});

export const batchMerge = createAction('STUDIO.BATCH_MERGE', () => {});
export const batchMergeFailure = createAction(
  'STUDIO.BATCH_MERGE_FAILURE',
  () => {}
);
export const batchMergeSuccess = createAction(
  'STUDIO.BATCH_MERGE_SUCCESS',
  () => {}
);

export const batchMoveToStash = createAction(
  'STUDIO.BATCH_MOVE_TO_STASH',
  () => {}
);

export const batchMoveToDrafts = createAction(
  'STUDIO.BATCH_MOVE_TO_DRAFTS',
  () => {}
);
